import { defineComponent as s, provide as l, inject as n } from "vue";
import { render as p } from "./index345.js";
let t = Symbol("ForcePortalRootContext");
function m() {
  return n(t, !1);
}
let i = s({ name: "ForcePortalRoot", props: { as: { type: [Object, String], default: "template" }, force: { type: Boolean, default: !1 } }, setup(o, { slots: e, attrs: r }) {
  return l(t, o.force), () => {
    let { force: f, ...a } = o;
    return p({ theirProps: a, ourProps: {}, slot: {}, slots: e, attrs: r, name: "ForcePortalRoot" });
  };
} });
export {
  i as ForcePortalRoot,
  m as usePortalRoot
};
